export default __webpack_public_path__ + "static/media/settings_selected.32654265.webp";